'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponentsReactiveGrid = require('styled-components-reactive-grid');

var _Text = require('../../elements/Text');

var _Text2 = _interopRequireDefault(_Text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FooterText(_ref) {
  var expanded = _ref.expanded,
      FooterMessage = _ref.FooterMessage;

  if (!expanded || !FooterMessage) {
    return null;
  }

  return _react2.default.createElement(
    _styledComponentsReactiveGrid.Column,
    { modifiers: ['col', 'padScaleX_4'], style: { overflow: 'hidden' } },
    _react2.default.createElement(
      _Text2.default,
      { modifiers: ['noWrap', 'small', 'textLight'] },
      _react2.default.createElement(FooterMessage, null)
    )
  );
}

FooterText.propTypes = {
  FooterMessage: _propTypes2.default.func,
  expanded: _propTypes2.default.bool.isRequired
};

FooterText.defaultProps = {
  FooterMessage: undefined
};

exports.default = FooterText;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/components/LeftNav/FooterText.js
// module id = 1669
// module chunks = 2